import { CreditCardEnum } from '../checkout/billingInfo';

export enum PaymentMethodTypesEnum {
  Ach = 'ach',
  Card = 'card',
}

export enum SupporterCCFieldsEnum {
  cardNumber = 'cardNumber',
  cardType = 'cardType',
  cvv = 'cvv',
  expirationDate = 'expirationDate',
  nameOnCard = 'nameOnCard',
  nickname = 'nickname',
}

export type SupporterCCDetails = {
  type: PaymentMethodTypesEnum.Card;
  [SupporterCCFieldsEnum.cardNumber]: string;
  [SupporterCCFieldsEnum.cardType]: CreditCardEnum;
  [SupporterCCFieldsEnum.cvv]: string;
  [SupporterCCFieldsEnum.expirationDate]: string;
  [SupporterCCFieldsEnum.nameOnCard]: string;
  [SupporterCCFieldsEnum.nickname]?: string;
};

export enum SupporterAchFieldsEnum {
  accountName = 'accountName',
  accountNumber = 'accountNumber',
  nickname = 'nickname',
  routingNumber = 'routingNumber',
}

export type SupporterAchDetails = {
  type: PaymentMethodTypesEnum.Ach;
  [SupporterAchFieldsEnum.accountName]: string;
  [SupporterAchFieldsEnum.accountNumber]: string;
  [SupporterAchFieldsEnum.nickname]?: string;
  [SupporterAchFieldsEnum.routingNumber]: string;
};

export type SupporterPaymentMethodDetails = (
  | SupporterCCDetails
  | SupporterAchDetails
) & {
  id?: string;
  type: PaymentMethodTypesEnum;
};
